"use client";

import { TagIcon } from "lucide-react";
import { CLUB_DISCOUNT_LABEL } from "@/service/shop/club-discount";

export function PromoCodeBanner() {
  return (
    <div className="border-remedium-blue/20 bg-remedium-blue/5 text-remedium-blue flex items-start gap-3 rounded-lg border px-4 py-3">
      <TagIcon className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="flex flex-col gap-1">
        <p className="text-sm font-semibold">
          {CLUB_DISCOUNT_LABEL} zniżki na wszystkie produkty, tylko z Klubem
          Medyka!
        </p>
      </div>
    </div>
  );
}
